<template>
    <div>

    </div>
</template>

<script>
    export default {
        props: {

        },
        data: function() {
            return  {

            }
        },
        methods: {
        },

    }
</script>

<style lang="scss" scoped>
    @import "../../../styles/_variables_home.scss";
    @import "../../../styles/common_home.scss";

</style>
